const UserTabItem = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="22"
            viewBox="0 0 17 22"
            fill="none"
        >
            <path
                d="M14.2118 12.9844C13.6291 12.1671 12.8388 11.4912 11.9447 11.0119C11.4897 10.7683 11.0107 10.5797 10.5077 10.4618C10.1804 10.3832 12.5274 10.1946 13.3736 7.25549C14.4673 3.42838 10.5237 -0.257277 6.71584 1.41659C4.86379 2.22602 3.57853 4.15923 3.62643 6.14744C3.65836 7.56198 4.28902 9.34587 6.58811 10.1946C4.37683 10.5168 3.06762 11.7663 2.18151 13.5895C0.920203 16.1828 0.952134 19.5463 1.02398 19.6406C1.08784 19.727 9.62962 22.8626 15.8963 19.3026C16.2076 19.1298 15.8643 15.2948 14.2118 12.9844Z"
                stroke="#686058"
            />
        </svg>
    )
}

export default UserTabItem
